// Promise-based replacements for window.confirm / alert / prompt, drawn by
// <DialogHost /> (mounted once in App) so they use the app's own look instead
// of the browser's native popup — which shows the site's raw address as its
// title ("virsavibe.….workers.dev says") and can't be styled at all.
//
//   const ok = await confirmDialog({ message: "Delete this?", confirmText: "Delete", danger: true });
//   await alertDialog("Couldn't save. Try again.");
//   const name = await promptDialog({ message: "Name this folder", maxLength: 15 }); // string | null

let openDialog = null;

export function registerDialogHost(fn) {
  openDialog = fn;
  return () => {
    if (openDialog === fn) openDialog = null;
  };
}

function normalize(options) {
  return typeof options === "string" ? { message: options } : options;
}

export function confirmDialog(options) {
  const opts = normalize(options);
  if (!openDialog) return Promise.resolve(window.confirm(opts.message));
  return openDialog({ ...opts, kind: "confirm" });
}

export function alertDialog(options) {
  const opts = normalize(options);
  if (!openDialog) {
    window.alert(opts.message);
    return Promise.resolve();
  }
  return openDialog({ ...opts, kind: "alert" });
}

export function promptDialog(options) {
  const opts = normalize(options);
  if (!openDialog) return Promise.resolve(window.prompt(opts.message, opts.defaultValue || ""));
  return openDialog({ ...opts, kind: "prompt" });
}

// The "log in to continue" gate used by every like/save/comment/follow button.
export function confirmLogin(message, confirmText = "Log in") {
  return confirmDialog({
    message: message || "Please log in to continue. Go to the login page now?",
    confirmText
  });
}
